import React from 'react';
const researchAreas = [
  {
    title: 'Artificial Intelligence',
    description: 'Advancing machine learning, natural language processing, and computer vision technologies.',
    faculty: 'Dr. Alan Turing, Dr. Fei-Fei Li',
    projects: 12
  },
  {
    title: 'Renewable Energy',
    description: 'Developing sustainable energy solutions and improving energy efficiency.',
    faculty: 'Dr. Maria Rodriguez, Dr. James Wilson',
    projects: 8
  },
  {
    title: 'Biomedical Engineering',
    description: 'Innovations in medical devices, biomaterials, and healthcare technologies.',
    faculty: 'Dr. Susan Park, Dr. Robert Chen',
    projects: 15
  },
  {
    title: 'Climate Change',
    description: 'Researching environmental impacts and developing mitigation strategies.',
    faculty: 'Dr. Emma Thompson, Dr. David Kim',
    projects: 10
  },
  {
    title: 'Cybersecurity',
    description: 'Protecting digital systems and networks from cyber threats.',
    faculty: 'Dr. Michael Johnson, Dr. Sarah Lee',
    projects: 9
  },
  {
    title: 'Quantum Computing',
    description: 'Exploring the next frontier of computational technology.',
    faculty: 'Dr. Richard Feynman, Dr. Michelle Zhang',
    projects: 7
  }
];

const Research = () => {
  return (
    <div className="min-h-screen bg-gray-50 py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h1 className="text-4xl font-bold text-gray-900 mb-4">Research at Our University</h1>
          <div className="w-24 h-1 bg-primary mx-auto mb-6"></div>
          <p className="text-xl text-gray-600 max-w-4xl mx-auto">
            Advancing knowledge and innovation through cutting-edge research across multiple disciplines.
          </p>
        </div>

        {/* Research Highlights */}
        <div className="mb-16">
          <h2 className="text-2xl font-semibold text-gray-800 mb-6">Research Highlights</h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
            <div className="bg-white p-6 rounded-lg shadow-md">
              <div className="text-4xl font-bold text-primary mb-2">46+</div>
              <p className="text-gray-600">Active Research Projects</p>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-md">
              <div className="text-4xl font-bold text-primary mb-2">$12M+</div>
              <p className="text-gray-600">Annual Research Funding</p>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-md">
              <div className="text-4xl font-bold text-primary mb-2">200+</div>
              <p className="text-gray-600">Research Publications Annually</p>
            </div>
          </div>
        </div>

        {/* Research Areas */}
        <div className="mb-16">
          <h2 className="text-2xl font-semibold text-gray-800 mb-6">Research Areas</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {researchAreas.map((area, index) => (
              <div key={index} className="bg-white rounded-lg shadow-md overflow-hidden hover:shadow-lg transition-shadow duration-300">
                <div className="p-6">
                  <h3 className="text-xl font-semibold text-gray-800 mb-2">{area.title}</h3>
                  <p className="text-gray-600 mb-4">{area.description}</p>
                  <div className="border-t border-gray-100 pt-4">
                    <p className="text-sm text-gray-500 mb-1">Faculty Leads:</p>
                    <p className="text-sm text-gray-700 mb-3">{area.faculty}</p>
                    <div className="flex justify-between items-center">
                      <span className="text-sm text-gray-500">{area.projects} active projects</span>
                      <button className="text-primary hover:underline text-sm font-medium">
                        Learn More →
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Research Centers */}
        <div>
          <h2 className="text-2xl font-semibold text-gray-800 mb-6">Research Centers & Institutes</h2>
          <div className="bg-white rounded-lg shadow-md p-6">
            <ul className="space-y-4">
              {[
                'Center for Artificial Intelligence Research',
                'Institute for Sustainable Energy',
                'Biomedical Innovation Hub',
                'Climate Change Research Initiative',
                'Cybersecurity Research Center',
                'Quantum Computing Institute'
              ].map((center, index) => (
                <li key={index} className="flex justify-between items-center py-2 border-b border-gray-100">
                  <span className="text-gray-800">{center}</span>
                  <button className="text-primary hover:underline text-sm font-medium">
                    Visit Center
                  </button>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
      
    </div>
  );
};

export default Research;
